<template>
  <div class="inactive-tradie-section">
    <div
      class="inactive-section-heading"
      role="button"
      tabindex="0"
      @click="$emit('toggle')"
      @keydown.enter.self="$emit('toggle')"
      @keydown.space.self.prevent="$emit('toggle')"
    >
      <b-icon-chevron-right
        class="expand-icon"
        :class="{ expanded: !collapsed }"
      />
      <span class="inactive-section-name">
        Not active · {{ tradies.length }}
        {{ tradies.length === 1 ? 'worker' : 'workers' }}
      </span>
    </div>
    <tradie-row
      v-show="!collapsed"
      v-for="row in tradies"
      :key="row.tradieId"
      :row="row"
      :row-key="row.tradieId + '-' + projectId"
      :project-id="projectId"
      :week-days="weekDays"
      :selected-day="selectedDayFn(row.tradieId + '-' + projectId)"
      :is-expanded="isExpandedFn(row.tradieId + '-' + projectId)"
      :can-create-timesheet="canCreateTimesheet"
      :can-edit-timesheet="canEditTimesheet"
      :can-delete-timesheet="canDeleteTimesheet"
      :is-supervisor-tradie="isSupervisorTradie"
      :editing-event-id="editingEventId"
      :edit-form="editForm"
      :max-future-date="maxFutureDate"
      inactive
      @toggle="$emit('row-toggle', $event)"
      @day-click="$emit('day-click', $event)"
      @view-event="$emit('view-event', $event)"
      @approve="forwardApprove"
      @reject="$emit('reject', $event)"
      @edit="$emit('edit', $event)"
      @save-edit="$emit('save-edit', $event)"
      @cancel-edit="$emit('cancel-edit')"
      @delete="$emit('delete', $event)"
      @edit-leave="$emit('edit-leave', $event)"
      @delete-leave="$emit('delete-leave', $event)"
      @lightbox="forwardLightbox"
    />
  </div>
</template>

<script>
import TradieRow from '@/components/timesheets/list/TradieRow.vue'

export default {
  name: 'InactiveTradieSection',
  components: { TradieRow },
  props: {
    tradies: { type: Array, default: () => [] },
    collapsed: { type: Boolean, default: false },
    canCreateTimesheet: { type: Boolean, default: false },
    canEditTimesheet: { type: Boolean, default: false },
    canDeleteTimesheet: { type: Boolean, default: false },
    isSupervisorTradie: { type: Boolean, default: false },
    projectId: { type: [Number, String], default: null },
    weekDays: { type: Array, default: () => [] },
    // Passed as functions rather than pre-resolved values because each row
    // needs its own (rowKey-keyed) result, and the parent already owns this
    // lookup state (TimesheetListTab's expandedTradies/selectedDay maps) for
    // the active tradie rows — reusing the same functions here keeps that
    // state in one place instead of duplicating it per section.
    isExpandedFn: { type: Function, default: () => false },
    selectedDayFn: { type: Function, default: () => null },
    editingEventId: { type: [Number, String], default: null },
    editForm: { type: Object, default: null },
    maxFutureDate: { type: String, default: '' },
  },
  methods: {
    forwardApprove(eventId, decision) {
      this.$emit('approve', eventId, decision)
    },
    forwardLightbox(urls, index) {
      this.$emit('lightbox', urls, index)
    },
  },
}
</script>

<style lang="scss" scoped>
.inactive-tradie-section {
  border-top: 1px solid #f1f5f9;
}

.inactive-section-heading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  user-select: none;
}

.inactive-section-name {
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
}

.expand-icon {
  font-size: 12px;
  color: #9ca3af;
  flex-shrink: 0;
  transition: transform 0.2s;

  &.expanded {
    transform: rotate(90deg);
  }
}
</style>
